import styled from 'styled-components'

export const Title = styled.span`
   font-size: 24px;
   font-weight: bold; 
   padding-top: 2.7rem;
   padding-bottom: 1.6rem;
   color: #252525;
`

export const Label = styled.span`
    color: #FF0000;
    font-size: 16px;
    font-weight: bold;
    margin-top: 1rem;
    display: flex;
    text-align: left;
    align-items: flex-start;
`